import { dataService } from 'App';


const contactListUrl = '/users/contacts';

export function getCircles() {
  return dataService.get(
    `${contactListUrl}/circles`,
  );
}

export function getCircleContacts(id,name) {

  return dataService.get(
    `${contactListUrl}/circle/contact/get/${id}?name=${name}`,
  );
}

export function addCircle(data) {
  return dataService.post(
    `${contactListUrl}/circle/add`, data, {}
  );
}

export function updateCircle(data) {
  return dataService.put(
    `${contactListUrl}/circle/update`, data, {}
  );
}

export function deleteCircle(id) {
  return dataService.delete(
    `${contactListUrl}/circle/delete/${id}`,
  );
}

export function deleteCircleContacts(id) {
  return dataService.delete(
    `${contactListUrl}/circle/deleteAll/${id}`,
  );
}

export function removeContacts(id,data) {
  return dataService.put(
    `${contactListUrl}/circle/contact/remove/${id}`,data,{}
  );
}

export function addContact(data) {
  return dataService.put(
    `${contactListUrl}/circle/contact/add`, data, {}
  );
}

export function updateContact(data) {
  return dataService.put(
    `${contactListUrl}/circle/contact/update`, data, {}
  );
}

export function addContactsFromFile(id, file) {
  let form = new FormData();
  form.append("file",file);
  return dataService.post(
    `circle/${id}/import?fields=MSISDN,NAME,EMAIL,BIRTHDATE,JOB`, form,
  );
}


export function getAllContacts(id, name) {
  return dataService.get(
    `/book/${id}/queryAll?name=${name}&page=0&size=3`,
  );
}


